import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LockIcon } from "assets/icons";
import { getIn, useFormik } from "formik";
import md5 from "md5";
import { YupValidations } from "utils/validation";
import * as Yup from "yup";

import AppButton from "components/button";

import FormInput from "./components/formInput";

const resetPasswordForm = props => {
  const { onSubmit, loading } = props;

  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    password: YupValidations.password,
    confirmPassword: YupValidations.confirmPassword,
  });

  const onSubmitForm = data => {
    onSubmit &&
      onSubmit({
        newPassword: md5(data.password),
        confirmPassword: md5(data.confirmPassword),
      });
  };

  const resetPasswordForm = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: onSubmitForm,
  });

  const { values, setFieldValue, handleSubmit, errors } = resetPasswordForm;

  useEffect(() => {
    console.log("form errors: ", errors);
  }, [errors]);

  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === "Enter") {
        event.preventDefault();

        handleSubmit();
      }
    };

    document.addEventListener("keydown", keyDownHandler);

    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [values]);

  const inputItems = [
    {
      type: "password",
      key: "password",
      value: "",
      placeholder: "label.placPassword",
      icon: <LockIcon />,
      span: 24,
      style: {
        paddingBottom: 4,
      },
    },
    {
      type: "password",
      key: "confirmPassword",
      value: "",
      placeholder: "label.placConfirmPassword",
      icon: <LockIcon />,
      span: 24,
      style: {
        paddingBottom: 4,
      },
    },
  ];

  return (
    <div>
      <FormInput
        items={inputItems.map(item => {
          item.label = t(item.label);
          if (item.key) {
            item.value = getIn(values, item.key);
          }
          return { ...item };
        })}
        form={resetPasswordForm}
        onChange={setFieldValue}
      />
      <AppButton
        label={t("label.resetPassword")}
        color={"primary"}
        loading={loading}
        type="submit"
        onClick={handleSubmit}
        className="authButton"
      />
    </div>
  );
};

export default resetPasswordForm;
